import {ContentItem} from "@/store/general/widget-content-items/state";
import Vue from 'vue';

export default Vue.extend({
    computed: {
        defaultStyles(): Record<string, string> {
            return {
                'margin-left': `${this.contentItem.level * 0.625}rem`
            };
        }
    },
    props: {
        contentItem: {
            type: Object as () => ContentItem,
            required: true
        },
        articleId: {
            type: Number,
            default: 0
        },
        projectId: {
            type: Number,
            default: 0
        },
    }
});
